module.exports = __webpack_public_path__ + "static/img/icons_raw_distribution_blue.592146c.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/menu-icons/icons_raw_distribution_blue.svg
// module id = wGRl
// module chunks = 1